import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
} from "@mui/material";
import * as React from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import { commonActions } from "../../../../redux/reducers/CommonReducer";
import { userActions } from "../../../../redux/reducers/UserReducer";
import * as userSiteActionsService from "../../../../services/ActionsService/UserSiteActionsService";
import store from "../../../../redux/Store";
import Strings from "../../../../resources/Strings";
import EllipseButton from "../../Buttons/EllipseButton/EllipseButton";
import classes from "./MessageModal.module.css";
import { UserSiteActivationEntity } from "../../../../entities/ServicesEntities/UserEntities/UserSiteActivationEntity";
import { showErrorMessage, showUpdateSuccessMessage } from "../../../../utils/MessagesUtils";
import { refreshSingleUserDataAndExtended } from "../../../../services/ParkerService";

const ParkerDisactiveMessageModal = (props) => {
  // manages the checkbox sites selection, sets the current userSites as checked
  const [selectedSites, setSelectedSites] = useState(
    props?.userData?.utronUser?.userSites?.filter(us => us.isActive)?.map(us => us.siteId.toString()));

  const messageModal = useSelector((state) => state.common.messageModal);

  // show allowed sites according to the usersSite
  const allowedUserSites = props?.userData?.utronUser?.userSites?.map(us => us?.site); 

  const handleClose = () => {
    if (messageModal.cancelAction) {
      messageModal.cancelAction();
    }
    store.dispatch(commonActions.closeMessageModal());
  };

  const handleChange = (event) => {
    let selectedSitesCopy = [...selectedSites];
    if (event.target.checked) {
      selectedSitesCopy.push(event.target.name);
    } else {
      const index = selectedSitesCopy.indexOf(event.target.name);
      if (index >= 0) {
        selectedSitesCopy.splice(index, 1);
      }
    }
    setSelectedSites(selectedSitesCopy);
  };

  const confirmAction = () => {
    const userData = props?.userData;

    // on every userSite check versus the checked selectedSites and map to UserSiteActivationEntity
    let userSitesActivationList = userData?.utronUser?.userSites
      ?.map(us => selectedSites.some(sl => parseInt(sl) === us.siteId) ? 
      new UserSiteActivationEntity(us.id, true) : 
      new UserSiteActivationEntity(us.id, false));
    
      userSiteActionsService.updateUserSitesActivation(userSitesActivationList, true, false).then((response) => {
        if (response.data.isSuccess) {
           store.dispatch(userActions.setUsersScope(userData.selectedScope.id));           
           const userId = userData?.utronUser?.id;
           if (userId) {
             refreshSingleUserDataAndExtended(userId, true, false)
               .then(() => {
                 showUpdateSuccessMessage();
               })
               .catch((error) => {
                 console.error('Error refreshing user data:', error);
                 showUpdateSuccessMessage(); // Still show success for the activation update
               });
           } else {
             showUpdateSuccessMessage();
           }
        }
        else {           
           console.log("response.data?.error", response.data?.error);
        }
      }).catch((error) => {
        console.log("error", error);
      });
  };

  return (
    <>
      <div>
          <FormControl
            required
            component="fieldset"
            className={classes.formControl}
          >
            <FormGroup className={classes.formGroup}>
            <div className={classes.centerList}>
              {allowedUserSites?.map((site) => {
                  return (
                    <FormControlLabel
                      key={site.id}
                      control={
                        <Checkbox
                          checked={selectedSites.includes(site?.id.toString())}
                          onChange={handleChange}
                          name={site?.id.toString()}
                          classes={{ checked: classes.checked }}
                        />
                      }
                      label={
                        <div className={classes.checkboxLabel}>
                          {site?.displayName}
                        </div>
                      }
                    />
                  );
                }) 
              } 
              </div>
            </FormGroup>
          </FormControl>
          <div className={classes.modalButtons}>
            <EllipseButton onClick={confirmAction}>
              {Strings.IM_SURE}
            </EllipseButton>
            <EllipseButton isCancelButton={true} onClick={handleClose}>
              {Strings.CANCEL}
            </EllipseButton>
          </div>
        </div>
    </>
  );
};

export default ParkerDisactiveMessageModal;
